import Vue from "vue";
import VueRouter from "vue-router";

// Routes
import { canNavigate } from "@/libs/acl/routeProtection";
import { isUserLoggedIn } from "@/auth/utils";

import pages from "@/router/routes/pages";
import dataManagement from "@/router/routes/data-management";
import product from "@/router/routes/product";
import banner from "@/router/routes/banner";
import inventory from "@/router/routes/inventory";
import privilege from "@/router/routes/privilege";
import report from "@/router/routes/report";
import article from "@/router/routes/article";
import survey from "@/router/routes/survey";
import tags from "@/router/routes/tags";
import fulfillment from "@/router/routes/fulfillment";
import documentPage from "@/router/routes/document";
import pdpa from "@/router/routes/pdpa";
import luckyWinner from "@/router/routes/lucky-winner";
import flashdeal from "./routes/flashdeal";
import customModule from "./routes/custom-module";
import aisPoint from "@/router/routes/ais-point";
import luckyDraw from "@/router/routes/lucky-draw";
import test from "@/router/routes/test";

Vue.use(VueRouter);

var router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/", redirect: { name: "landing" } },
    { path: "/hub", redirect: { name: "hub" } },
    { path: "/new-password", redirect: { name: "new-password" } },
    { path: "/forget-password", redirect: { name: "forget-password" } },
    { path: "/error", redirect: { name: "error" } },
    { path: "/version", redirect: { name: "version" } },
    {
      path: "*",
      redirect: "error-404",
    },
    ...pages,
    ...dataManagement,
    ...product,
    ...inventory,
    ...privilege,
    ...report,
    ...banner,
    ...article,
    ...survey,
    ...tags,
    ...fulfillment,
    ...documentPage,
    ...pdpa,
    ...luckyWinner,
    ...flashdeal,
    ...customModule,
    ...aisPoint,
    ...luckyDraw,
    ...test,
  ],
});

const isLoggedIn = isUserLoggedIn();
router.beforeEach((to, _, next) => {
  // Redirect to login if not logged in
  if (!canNavigate(to)) {
    if (!isLoggedIn) return next({ name: "auth-login" });
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next();
  }

  return next();
});

router.afterEach(() => {
  // Remove initial loading
  // const appLoading = document.getElementById("loading-bg");
  // if (appLoading) {
  //   appLoading.style.display = "none";
  // }
});

export default router;
